<template>
  <div
    class="suscripcion-widget d-none d-md-block"
    style="bottom: 110px; left: 20px;"
    data-toggle="modal"
    data-target="#WhatsappManagerPopUp"
  >
    <img src="@/assets/widget-whastapp.png" class="img-whatsapp" />
  </div>
</template>

<script>
export default {
  name: 'WhatsappWidget',
  props: ['configData'],
};
</script>
